export const PRODUCT_RECEIVE = 'PRODUCT_RECEIVE';
export const PRODUCT_FETCH_ERROR = 'PRODUCT_FETCH_ERROR';

export const PRODUCT_RATE_REQUEST = 'PRODUCT_RATE_REQUEST';
export const PRODUCT_REVIEW_FAILED = 'PRODUCT_REVIEW_FAILED';

export const PRODUCT_PRICE_CLICK = 'PRODUCT_PRICE_CLICK';

export const PRODUCT_NAVIGATION = 'PRODUCT_NAVIGATION';

export const PRODUCT_PRICE_CLICK_BOUNCE = 'PRODUCT_PRICE_CLICK_BOUNCE';
export const PRODUCT_HEADER_CLICK = 'PRODUCT_HEADER_CLICK';

export const PRODUCT_VARIANT_SELECTED = 'PRODUCT_VARIANT_SELECTED';

export const PRICE_SHIPPING_SORT = 'PRICE_SHIPPING_SORT';
export const PRICE_GROUPING = 'PRICE_GROUPING';

// NOTE: Any changes done to data or structure of PRODUCT_PRICE_CLICK needs to be
// reflected in react/middlewares/out.js pre click for tracking clicks before JS bundle
export const productPriceClick = (
  productId,
  price,
  featured,
  status,
  isAlternative,
  isSplitList
) => ({
  type: PRODUCT_PRICE_CLICK,
  productId,
  price,
  featured: featured ? 'Featured' : 'Not Featured',
  status,
  isAlternative,
  isSplitList,
});

export const productNavigation = (action, index) => ({
  type: PRODUCT_NAVIGATION,
  action,
  index,
});

export const productClickOutBounce = (productId, priceId) => ({
  type: PRODUCT_PRICE_CLICK_BOUNCE,
  productId,
  priceId,
});

export const headerClickEvent = event => ({
  type: PRODUCT_HEADER_CLICK,
  event,
});

export const setSelectedVariant = variant => ({
  type: PRODUCT_VARIANT_SELECTED,
  variant,
});

export const priceShippingSort = sort => ({
  type: PRICE_SHIPPING_SORT,
  sort,
});

export const priceGrouping = grouping => ({
  type: PRICE_GROUPING,
  grouping,
});
